import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52d85d8a")

_pushScopeId("data-v-52d85d8a")
const _hoisted_1 = { class: "select-attribute" }
const _hoisted_2 = { class: "tile" }
const _hoisted_3 = { class: "option_header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "option_title" }, " オプション絞り込み条件 ", -1)
const _hoisted_5 = { class: "option_link" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Optiondialog = _resolveComponent("Optiondialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("p", _hoisted_5, [
          _createVNode("button", {
            class: "link-style-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openOption && _ctx.openOption(...args)))
          }, " 一例を見る ")
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attributeGroup.attributes, (attr) => {
        return (_openBlock(), _createBlock("div", {
          class: "checkbox-list",
          key: attr.id
        }, [
          _withDirectives(_createVNode("input", {
            type: "checkbox",
            id: `attrid_${attr.id}`,
            value: attr.id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedList = $event))
          }, null, 8, ["id", "value"]), [
            [_vModelCheckbox, _ctx.selectedList]
          ]),
          _createVNode("label", {
            for: `attrid_${attr.id}`
          }, _toDisplayString(attr.name), 9, ["for"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Optiondialog, {
      isShowModal: _ctx.isShowModal,
      "onUpdate:isShowModal": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowModal = $event))
    }, null, 8, ["isShowModal"])
  ]))
})